import type { PropsWithChildren } from 'react';

import { FormField, FormHelp, Label } from '@zillow/constellation-10';

import YesAndNoExpansion from '../../../Widgets/YesAndNoExpansion';

type Props = {
  yesHandler: () => void;
  noHandler: () => void;
  yesActive: boolean;
  dataTest?: string;
  className?: string;
  subTitle?: string;
  disabled?: boolean;
};

export default function SecurityDepositYesAndNoExpansion({
  children,
  subTitle,
  dataTest,
  disabled,
  yesActive,
  ...rest
}: PropsWithChildren<Props>) {
  return (
    <FormField
      required
      disabled={disabled}
      label={<Label>Will you collect a security deposit?</Label>}
      control={
        <YesAndNoExpansion data-test={dataTest} disabled={disabled} yesActive={yesActive} {...rest}>
          {children}
        </YesAndNoExpansion>
      }
      description={!yesActive && subTitle && <FormHelp>{subTitle}</FormHelp>}
    />
  );
}
